import { Col, Row } from 'antd'
import React from 'react'
import LeftControl from '../LeftControl'
import ContactInfoForm from './ContactInfoForm'

const ApplicationContact = () => {
    return (
        <div>
            <Row className="Liq-Container HRPortal">
                <Col md={3} className="LeftContol1" id="LeftContol">
                    <LeftControl />
                </Col>
                <Col md={20} className="ContentPage FormTableArea">
                    <ContactInfoForm />
                </Col>
            </Row>
        </div>
    )
}

export default ApplicationContact